import { TemplateTaskActionTypes } from "./template-task-types";

const INITIAL_STATE = {
  allTemplateTasks: null,
  searchTemplateTasksQuery: {
    pageSize: 10,
    pageNumber: 1,
    sortDesc: false,
    sortBy: "Name",
    filters: [],
  },
  isFetchingTemplateTasks: false,
  isFetchingAllTemplateTasks: false,
  templateTasks: [],
  templateTasksOnPage: null,
  numTemplateTasks: 0,
  selectedTemplateTasks: [],
};

const templateTaskReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TemplateTaskActionTypes.FETCH_TEMPLATE_TASKS_START:
      return {
        ...state,
        isFetchingTemplateTasks: true,
      };

    case TemplateTaskActionTypes.FETCH_TEMPLATE_TASKS_SUCCESS:
      return {
        ...state,
        isFetchingTemplateTasks: false,
        templateTasks: action.payload[0],
        numTemplateTasks: action.payload[1],
      };

    case TemplateTaskActionTypes.FETCH_TEMPLATE_TASKS_FAILURE:
      return {
        ...state,
        isFetchingTemplateTasks: false,
        errorMessage: action.payload,
      };
    case TemplateTaskActionTypes.SET_TEMPLATE_TASKS_ON_PAGE: //setting the tasks that are displayed on the page
      return {
        ...state,
        templateTasksOnPage: action.payload,
      };

    case TemplateTaskActionTypes.SET_SEARCH_TEMPLATE_TASKS_QUERY:
      return {
        ...state,
        searchTemplateTasksQuery: action.payload,
      };

    case TemplateTaskActionTypes.ADD_SELECTED_TEMPLATE_TASKS:
      return {
        ...state,
        selectedTemplateTasks: [...state.selectedTemplateTasks, action.payload],
      };

    case TemplateTaskActionTypes.DELETE_SELECTED_TEMPLATE_TASKS:
      return {
        ...state,
        selectedTemplateTasks: [
          ...state.selectedTemplateTasks.slice(
            0,
            state.selectedTemplateTasks.indexOf(action.payload)
          ),
          ...state.selectedTemplateTasks.slice(
            state.selectedTemplateTasks.indexOf(action.payload) + 1
          ),
        ],
      };
    case TemplateTaskActionTypes.SET_SELECTED_TEMPLATE_TASKS:
      return {
        ...state,
        selectedTemplateTasks: action.payload,
      };

    default:
      return state;
  }
};

export default templateTaskReducer;
